import { telaIdsToNumber, TelasIds } from "../../../../../common/utils/tela_ids";
import { IGetOrdemCompraByIdUseCase } from "../../../presentation/useCases/read/get_ordem_compra_by_id_use_case";
import { OrdemCompraDetalhes } from "../../models/ordem_compra_detalhes";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetOrdemCompraByIdUseCase
 */

export class GetOrdemCompraByIdUseCase implements IGetOrdemCompraByIdUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getOrdemCompraById(
    telaId: TelasIds,
    idOrdemCompra: number | undefined,
  ): Promise<OrdemCompraDetalhes> {
    if (idOrdemCompra === undefined) throw new Error('Falha ao buscar id de ordem de compra!');
    const result = await this.repository.getOrdemCompraById(
      telaIdsToNumber(telaId),
      idOrdemCompra,
    );
    if (result === null) throw new Error('Falha ao buscar ordem de compra!');
    return result;
  }
}
